<template>
    <div>
        <h5 class="font-weight-bolder">{{ $t('manage_your_bank_account') }}</h5>
        <div v-show="bankAccounts.length == 0" class="">
            {{ $t('no_bank_accounts_on_file') }}
        </div>
         <div class="font-weight-bolder py-5">{{ $t('add_bank_account_details') }}</div>
         <Form @submit="submitBankAccountPaymentMethod" :validation-schema="schema" v-slot="{errors}" ref="form" role="form">
         <div class="form-group row"> 
            <label class="font-weight-bolder align-self-center col-md-2">{{ $t('account_holder_name_required') }}</label>
            <div class="col-md-6">
                <Field type="text" name="account_holder_name" v-model="account_holder_name" :placeholder="$t('enter_account_holder_name')" class="form-control" :class="{ 'is-invalid': errors.account_holder_name }"/>
                <ErrorMessage name="account_holder_name" class="error-message"/>
            </div>
         </div>
        <div class="form-group row">
            <label class="font-weight-bolder align-self-center col-md-2">{{ $t('account_holder_type_required') }}</label>
            <div class="col-md-6">
               <div class="radio-inline">
                    <label class="radio">
                        <input id="account_holder_type_company" name="account_holder_type" type="radio" v-model="account_holder_type" value="Company" class="form-control mb-2">
                        <span></span>{{ $t('company') }}
                     </label>
                    <label class="radio">
                        <input id="account_holder_type_individual" name="account_holder_type" type="radio" v-model="account_holder_type" value="Individual" class="form-control mb-2">
                        <span></span>{{ $t('individual') }}
                   </label>

                </div>
            </div>
         </div>

        <div class="form-group row">
            <label class="font-weight-bolder align-self-center col-md-2">{{ $t('routing_number_required') }}</label>
             <div class="col-md-6">
                <Field type="text" name="routing_number" v-model="routing_number" :placeholder="$t('enter_routing_number')" class="form-control" :class="{ 'is-invalid': errors.routing_number }"/>
                <ErrorMessage name="routing_number" class="error-message"/>
             </div>
        </div>
        <div class="form-group row">
            <label class="font-weight-bolder align-self-center col-md-2">{{ $t('account_number_required') }}</label>
            <div class="col-md-6">
                <Field type="text" name="account_number" v-model="account_number" :placeholder="$t('enter_account_number')" class="form-control" :class="{ 'is-invalid': errors.account_number }"/>
                <ErrorMessage name="account_number" class="error-message"/>
            </div>
        </div>
        <div class="row">
            <label class="font-weight-bolder align-self-center col-md-2"></label>
            <div class="col-md-6">
                <label class="checkbox checkbox--solid">
                <input id="authorize" type="checkbox" v-model="authorize" class="form-control mb-2"> 
                <span class="mr-3"></span>
                {{ $t('authorize')}} {{ brand_name }} {{$t('to_debit_my_account_text')}}
            </label>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary mt-3" id="add-card-button">
                {{ $t('save_bank_account') }}
            </button>
        </div>
        <div id="error-message" role="alert" class="text-danger mt-2 mb-2"></div>
        <div  class="outcome">
            <div class="error text-danger"></div>
        </div>
         </Form>

        <!-- List all bank accounts of this customer -->

        <div v-if="bankAccounts.length > 0">
            <div v-for="(bank, key) in bankAccounts">
                <div v-if="bank.type == 'bank_account'"
                     v-bind:key="'bank-'+key"
                     v-on:click="bankAccSelected = bank.id"
                     class="border rounded row p-1 mt-7"
                     >
                    <div class="col-2 mt-3">
                        <template v-if="bank.name">
                            {{ bank.name }}
                        </template>
                    </div>
                    <div class="col-3 mt-3">
                        {{ $t('ending_in') }}: {{ bank.last_four }}
                    </div>
                    <div class="col-4 mt-3">
                         <template v-if="bank.status != 'verified'">
                            {{ $t('status') }}: {{ $t('pending_verification') }}
                        </template>
                        <template v-else>
                           {{ $t('status') }}: <span class="text-capitalize"> {{ bank.status }} </span>
                        </template>
                       
                    </div>
                    <div class="col-3 text-right pr-0">
                        <a href="javascript:;" id="delete-bank-account" class="btn btn-danger btn-sm" :title="$t('delete_bank_account')" data-toggle="tooltip"><span v-on:click.stop="removeBankAccount( bank.id, bank.associated_customer )"><i class="nav__link-icon flaticon2-trash"></i> </span></a>
                        <a href="javascript:;" id="verify-bank-account" class="btn btn-success btn-sm ml-2" :title="$t('verify_bank_account')" data-toggle="tooltip" v-if="bank.status != 'verified'" v-on:click.stop="triggerVerifyBankAccountModal( bank.id, bank.associated_customer )"><span><i class="nav__link-icon far fa-check-square"></i></span></a>
                    </div>
                </div>
            </div>
        </div>

        <!--begin::Verify Bank Account Modal component-->
        <!-- Two positive integers, in cents, equal to the values of the microdeposits sent to the bank account. -->

        <div class="modal fade show bank-verification-modal" tabindex="-1" role="dialog" aria-labelledby="bankAccountVerificationModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <Form class="form form--label-right" @submit="verifyBankAccount" :validation-schema="cardSchema" v-slot="{errors}" ref="resetform" role="form">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $t('verify_micro_deposits_for_ach') }}</h5>
                            <button type="button" class="close" data-dismiss="modal" :aria-label="$t('close')">
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group row">
                                <div class="col-lg-12">
                                    <p class="modal-title">{{ $t('stripe_microdeposit_verification_instruction') }}</p><br>
                                </div>
                                <div class="col-lg-6">
                                    <label class="">{{ $t('first_amount') }}*:</label>
                                    <Field type="text" name="first_amount" v-model="first_amount" :placeholder="$t('enter_amount')" class="form-control" :class="{ 'is-invalid': errors.first_amount }"/>
                                    <ErrorMessage name="first_amount" class="error-message"/>
                                </div>
                                <div class="col-lg-6">
                                    <label class="">{{ $t('second_amount') }}*:</label>
                                    <Field type="text" name="second_amount" v-model="second_amount" :placeholder="$t('enter_amount')" class="form-control" :class="{ 'is-invalid': errors.second_amount }"/>
                                    <ErrorMessage name="second_amount" class="error-message"/>
                                </div>
                                <div class="col-lg-12 pt-4 text-muted mt-5" style="line-height:1.5;">
                                    <ul>
                                        <li>{{ $t('microdeposit_transfer_timing') }}</li>
                                        <li>{{ $t('microdeposit_verification_attempts') }}</li>
                                        <li>{{ $t('microdeposit_max_attempts') }} <a rel="noopener noreferrer" id="contact-stripe-support" href="https://support.stripe.com/email"><span>{{ $t('contact_stripe_support') }}</span></a> {{ $t('for_additional_assistance') }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" id="close_bank_modal" class="btn btn-secondary" data-dismiss="modal" v-on:click="modalReset()">{{ $t('close') }}</button>
                            <button type="submit" id="save_bank_modal" :class="{'btn btn-primary': true, 'spinner spinner-white spinner-right disabled': this.spinner }">{{ $t('save') }}</button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>

        <!--end::Verify Bank Account Modal component-->

    </div>

</template>
<script>
    // 397 to 438
    import CustomerAPIService from '@/js/api/customers/customers';
    import { Field, Form, ErrorMessage } from 'vee-validate';
import { toast } from 'vue3-toastify';
    import * as yup from 'yup';
    export default {
        props: ['customerId', 'customerType', 'country', 'currency', 'CONNECTED_STRIPE_ACCOUNT_ID'],
        components: {
            Form,
            Field,
            ErrorMessage,
        },
        data(){
            return {
                stripeAPIToken: import.meta.env.VITE_STRIPE_BILLING_API_KEY,
                brand_name: '',

                account_holder_name: '',
                account_holder_type: 'Individual',
                routing_number: '',
                account_number: '',
                authorize: '',
                errorMessage: '',

                bankAccounts:[],
                bankAccSelected: {},
                first_amount: '',
                second_amount: '',

                bank_id_2_verify:'',
                customer_id_2_verify: '',
                spinner: false,
                buttonDisable: false,
              
            }
        },
        mounted(){
            this.includeStripe('js.stripe.com/v3/', function(){
                this.configureStripe();
            }.bind(this) );
            this.loadIntent();
            this.loadBankAccounts();
        },
        computed:{
            schema(){
                return yup.object({
                    account_holder_name: yup.string().required('Account Holder Name is required'),
                    routing_number: yup.string().required('Rounting Number is required'),
                    account_number: yup.string().required('Account Number is required')
                })
            },
            cardSchema(){
                return yup.object({
                    first_amount: yup.string().required('First Amount is required').matches(/^\d+(\.\d{1,2})?$/, 'First Amount must be a valid decimal number with up to 2 decimal places'),
                    second_amount: yup.string().required('Second Amount is required').matches(/^\d+(\.\d{1,2})?$/, 'Second Amount must be a valid decimal number with up to 2 decimal places')
                })
            }
        },
        watch: {
            country(){
                return this.country;
            },
            currency(){
                return this.currency;
            }
        },
        methods: {

            /*
                Includes Stripe.js dynamically
            */
            includeStripe( URL, callback ){
                let documentTag = document, tag = 'script',
                    object = documentTag.createElement(tag),
                    scriptTag = documentTag.getElementsByTagName(tag)[0];
                object.setAttribute('defer', 'defer'); // check if it required.
                object.src = '//' + URL;
                if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
                scriptTag.parentNode.insertBefore(object, scriptTag);
            },
            /*
                Configures Stripe by setting up the elements and
                creating the card element.
            */
            configureStripe(){
                // Set the connected Stripe Account on which the PaymentMethod should be created
                this.stripe = Stripe(this.stripeAPIToken, { stripeAccount: this.CONNECTED_STRIPE_ACCOUNT_ID});
                this.elements = this.stripe.elements();
                this.errorMessage = document.getElementById('error-message');
                

            },

            /*
                Loads the payment intent key for the user to pay.
            */
            loadIntent(){
                CustomerAPIService.getStripeBillingIntent(this.customerId, this.customerType, this.access_token)
                    .then((response) => {
                        this.intentToken = response.data;
                    }).catch((error) => {
                    this.notify("Error Exception!", error , "error");
                });
            },

            submitBankAccountPaymentMethod(){
                let self = this;
                if(self.authorize){
                    if(!self.CONNECTED_STRIPE_ACCOUNT_ID){
                        this.notify("Error Exception!","Stripe account is still loading, please try again in a moment.", "error");
                        return;
                    }

                    /*
                        Build a fresh Stripe.js client scoped to the connected account right before use.
                        CONNECTED_STRIPE_ACCOUNT_ID arrives asynchronously from the parent component, so
                        the "this.stripe" instance built in configureStripe() (mounted hook) may still have
                        been created with stripeAccount undefined, which would create the PaymentMethod on
                        the platform account instead of the connected account.
                    */
                    let stripeClient = Stripe(this.stripeAPIToken, { stripeAccount: self.CONNECTED_STRIPE_ACCOUNT_ID });

                    // account_holder_type must be lowercase for the us_bank_account PaymentMethod API.
                    stripeClient.createPaymentMethod({
                        type: 'us_bank_account',
                        us_bank_account: {
                            account_holder_type: self.account_holder_type.toLowerCase(),
                            routing_number: self.routing_number,
                            account_number: self.account_number,
                        },
                        billing_details: {
                            name: self.account_holder_name,
                        },
                    }).then(self.stripeACHSourceHandler);
                    this.formReset();
                } else {
                    this.notify("Error Exception!","Please select \"I authorize to electronically debit my account ...\" checkbox to proceed.", "error");
                }
            },

            stripeACHSourceHandler(result){

                if (result.paymentMethod) {

                    let data = {
                        country: this.country,
                        currency: this.currency,
                        customerId: this.customerId,
                        customerType: this.customerType,

                        account_holder_name: this.account_holder_name,
                        account_holder_type: this.account_holder_type,
                        authorize: this.authorize,
                        payment_method_id: result.paymentMethod.id,
                    }
                    this.$store.commit('SHOW_LOADER',true);
                    CustomerAPIService.saveStripeBankAccount(data, this.access_token)
                        .then((response) => {
                            this.$store.commit('SHOW_LOADER',false);
                            this.loadBankAccounts();
                            // Clear form fields
                            this.account_holder_name = '';
                            this.routing_number = '';
                            this.account_number = '';
                            this.authorize = '';
                            swal.fire("Success!", "Bank account created successfully", "success");
                        }).catch((error) => {
                            this.$store.commit('SHOW_LOADER',false);
                            if (error.response) {
                                this.notify("Error Exception!", error.response.data.message, "error");
                            } else {
                                this.notify("Error Exception!","Error", "error");
                            }
                        });
                } else if (result.error) {
                    this.notify("Error Exception!",result.error.message, "error");
                }
            },

            /*
                Loads all of the payment methods for the
                user.
            */
            loadBankAccounts(){
                this.$store.commit('SHOW_LOADER',true);
                CustomerAPIService.getStripeBillingBankAccounts(this.customerId, this.customerType, this.access_token)
                    .then((response) => {
                        this.$store.commit('SHOW_LOADER',false);
                        this.bankAccounts = response.data;
                        this.paymentMethodsLoadStatus = 2;
                    }).catch((error) => {
                        this.$store.commit('SHOW_LOADER',false);
                    this.notify("Error Exception!","Error", "error");
                });
            },
            removeBankAccount: function(bankAccountId, customerStripeId){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, remove it!'
                }).then((result) => {
                    if (result.value) {
                        let data = {
                            customerId: this.customerId,
                            customerType: this.customerType,
                            id: bankAccountId,
                            customerStripeId: customerStripeId
                        }
                        this.$store.commit('SHOW_LOADER',true);
                        CustomerAPIService.removeStripeBillingBankAccount(data, this.access_token)
                            .then((response) => {
                                this.$store.commit('SHOW_LOADER',false);
                                this.loadBankAccounts();
                            }).catch((error) => {
                            this.$store.commit('SHOW_LOADER',false);
                            swal.fire("Error Exception!","Error", "error");
                        });
                    }
                });


            },
            triggerVerifyBankAccountModal: function(bankAccountId, customerStripeId){
                this.bank_id_2_verify = bankAccountId;
                this.customer_id_2_verify = customerStripeId;
                $('.bank-verification-modal').modal('show');
            },
            verifyBankAccount: function(bankAccountId, customerStripeId){
                let data = {
                    stripe_cusomer_id: this.customer_id_2_verify,
                    bank_account_id: this.bank_id_2_verify,
                    first_amount: this.first_amount,
                    second_amount: this.second_amount,
                    customerId: this.customerId,
                    customerType: this.customerType,
                }
                    this.spinner = true;
                CustomerAPIService.verifyStripeBillingBankAccount(data, this.access_token)
                    .then((response) => {
                        this.loadBankAccounts();
                        this.notify("Success!","Verified","success");
                        this.bank_id_2_verify = '';
                        this.customer_id_2_verify = '';
                        $('.bank-verification-modal').modal('hide');
                        this.spinner = false;
                        this.first_amount='';
                        this.second_amount='';
                    }).catch((error) => {
                        this.spinner = false;
                        if (error.response) {
                            this.notify("Error Exception!", error.response.data.message, "error");
                        } else {
                            this.notify("Error Exception!","Error", "error");
                        }
                    });
            },
            formReset() {
            this.account_holder_name= "";
            this.routing_number= "";
            this.account_number= "";

             // Clear vee-validate errors
            this.$refs.form.resetForm();
            },
            modalReset() {
            this.first_amount="";
            this.second_amount="";
            // Clear vee-validate errors
            this.$refs.resetform.resetForm();
            },
        }
    }
</script>
